const { Type } = require('@sinclair/typebox');
const { merge } = require('lodash');
const { moduleRegistration } = require('@sstdev/lib_metadata-config');

/** Builds the TypeBox schema fragment for the MultiPickerSensorGrid form element. */
function asDataDictionary(hNode, context) {
    const { id, title, propertyName } = hNode;

    // Process children (list columns) to extract any sub data dictionary info
    let [subDataDictionary = {}, _partialTypeDefinition = {}] = hNode.children?.reduce(
        ([sdd, ptd], child) => {
            const [_subDataDictionary = {}, _partialTypeDefinition = {}] = context.extractFromChild(child, context);
            return [
                merge(sdd, _subDataDictionary),
                moduleRegistration.mergePartialTypeDefinitions(ptd, _partialTypeDefinition, context)
            ];
        },
        [{}, {}]
    ) ?? [{}, {}];

    // MultiPickerSensorGrid items can contain various properties from sensor reads
    // Use additionalProperties: true to allow any properties on items
    // Columns describe displayed rows; selecting an item does not require every column value.
    const itemSchema = Type.Partial(
        Type.Object(_partialTypeDefinition, {
            title: 'Item',
            'x-dataType': 'object',
            additionalProperties: true
        })
    );

    // MultiPickerSensorGrid is always optional and editable
    const arraySchema = Type.Optional(
        Type.Array(itemSchema, {
            title: title,
            'x-id': id,
            'x-dataType': 'array',
            'x-propertyName': propertyName,
            'x-optional': true,
            'x-editable': true
        })
    );

    // The partial type definition uses the propertyName from the block
    const partialTypeDefinition = {
        [propertyName]: arraySchema
    };

    return [subDataDictionary, partialTypeDefinition];
}

module.exports = { asDataDictionary };
